import { render } from "./InstitutionTables.vue?vue&type=template&id=59e4dda2&lang=pug"
import script from "./InstitutionTables.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutionTables.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__